import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "flexcontainer pt-3 pl-5 pr-5 page-fill" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col flex-1 min-h-0 overflow-hidden"
}
const _hoisted_3 = { class: "row w-full flex justify-between" }
const _hoisted_4 = { class: "flex flex-row-reverse gap-3" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_7 = { class: "table-section" }
const _hoisted_8 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_9 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_10 = { class: "formcontainer flex flex-col" }
const _hoisted_11 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_14 = {
  key: 0,
  class: "error-text"
}
const _hoisted_15 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_16 = { class: "row flex flex-row w-full" }
const _hoisted_17 = { class: "w-6/12" }
const _hoisted_18 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_19 = {
  key: 0,
  class: "error-text"
}
const _hoisted_20 = {
  key: 1,
  class: "error-text"
}
const _hoisted_21 = {
  key: 0,
  class: "buttonposition flex justify-center items-center mb-4 mx-0"
}
const _hoisted_22 = {
  key: 1,
  class: "buttonposition flex justify-center items-center mb-4 mx-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[9] || (_cache[9] = _createElementVNode("h1", { class: "title" }, "Master KPI's", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: _normalizeClass(["flex", !_ctx.columnObject ? 'filterButton' : 'filterButtondisabled pointer-events-none']),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
              }, [
                (_ctx.columnObject)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                  : (_openBlock(), _createElementBlock("img", _hoisted_6)),
                _cache[8] || (_cache[8] = _createTextVNode(" Filters "))
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_tableData, {
              class: "flex-1 min-h-0",
              tableRowData: _ctx.tableRow,
              headersData: _ctx.headers
            }, null, 8, ["tableRowData", "headersData"])
          ]),
          (_ctx.showPopup)
            ? (_openBlock(), _createBlock(_component_popup, {
                key: 0,
                popUp: _ctx.showPopup
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "pl-2" }, "Manage KPI", -1)),
                    _createElementVNode("button", {
                      class: "float-right text-3xl",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => {
								_ctx.onCancelbtn();
								this.showPopup = false;
							})
                    }, _cache[10] || (_cache[10] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "controllabel" }, "KPI Name", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text",
                                  class: _normalizeClass(["inputboxstyling h-20 max-h-48 mt-2", {
													'is-invalid': _ctx.v$.allKpis.description.$error
												}]),
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.allKpis.description) = $event)),
                                  placeholder: "KPI Name"
                                }, null, 2), [
                                  [_vModelText, _ctx.allKpis.description]
                                ]),
                                (_ctx.v$.allKpis.description.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      (_ctx.v$.allKpis.description.required)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "controllabel" }, "Weightage (%)", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: _normalizeClass(["inputboxstyling mt-2", {
														'is-invalid': _ctx.v$.allKpis.weightage.$error
													}]),
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.allKpis.weightage) = $event)),
                                    maxlength: "3",
                                    ref: "editWeight",
                                    placeholder: "Weightage (%)"
                                  }, null, 2), [
                                    [_vModelText, _ctx.allKpis.weightage]
                                  ]),
                                  (_ctx.v$.allKpis.weightage.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        (_ctx.v$.allKpis.weightage.required)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Weightage (%) is required"))
                                          : (_ctx.v$.allKpis.weightage.numeric.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Weightage(%) is Invalid"))
                                            : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.allKpis._id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onCancelbtn()))
                            }, "Cancel", 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(_ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'),
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addOrUpdate(_ctx.allKpis)))
                            }, "Update", 2)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["mr-1.5", _ctx.disableStatus ? 'btndisabled pointer-events-none' : 'btnprimary']),
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onCancelbtn()))
                            }, "Cancel", 2),
                            _createElementVNode("button", {
                              class: _normalizeClass(_ctx.disableStatus ? 'btndisabled pointer-events-none' : 'btnprimary'),
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addOrUpdate(_ctx.allKpis)))
                            }, "Save", 2)
                          ]))
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["popUp"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}